import { render } from "./VarifyForm.vue?vue&type=template&id=121b5100&ts=true"
import script from "./VarifyForm.vue?vue&type=script&lang=ts"
export * from "./VarifyForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__